<template>
<otif-draggableList v-model="urlFilters">
    <template slot="add" >
        <otif-select v-model="filter" :values="filterTypes"  class="OTdropInside"/>
        <otif-textInput class="OTdropInsideInput" v-model="url" @keydown.native="onEnter" :placeholder="placeholder" />
        <b-button @click.prevent="addUrl"  class="OTbutton-primary btnFormInline"><otif-icon icon="plus"/>Add</b-button>

    </template>

    <template slot="chiclet" slot-scope="{ items, onRemove }" class="list-group list-group-flush OTchickletFormContainer OTchickletFormContainerWebCriteria OTchicletLong">
        <li class="list-group-item OTchiclet OTchicletLong OTchicletNoBorder" v-for="(url, idx) in urls" :class="(filters[idx] === 'INCLUDE')? 'OTchiclet-Include' : 'OTchiclet-Exclude'">
            <otif-icon icon="drag" ></otif-icon>
            <otif-select  class="OTdropInside" :value="filters[idx]" @input="changeFilter($event, idx)" :values="filterTypes"/>
            <otif-textInput :value="urls[idx]" @input="changeUrl($event, idx)"/>
            <otif-icon icon="chiclet" @click="onRemove(idx)" />
        <div class="clearfix"></div>
        </li>
        <otif-radio :values="everythingElseValues" v-model="filterEverything" name="filterEverything" :formName="filterEverything"></otif-radio>

    </template>
</otif-draggableList>
</template>

<script>

export default {
    data() {
        return {
            url: '',
            filter: 'INCLUDE',
            everythingElseValues: [{
                label: 'Skip everything else',
                value: 'EXCLUDE'
            },{
                label: 'Include everything else',
                value: 'INCLUDE'
            }],
            filterTypes: [{
                label: 'Exclude',
                value: 'EXCLUDE'
            },{
                label: 'Include',
                value: 'INCLUDE'
            }]
        }
    },

    props: ['label', 'value', 'placeholder'],

    computed: {
        urlFilters: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
            }
        },
        urls: {
            get() {

                if (!this.value) {
                    return [];
                }

                const lastItem = this.value[this.value.length-1];

                if (lastItem && lastItem.expression === '.') {
                    return this.value.slice(0,this.value.length-1).map((i) => {
                        return i.expression;
                    });
                } else {
                    return this.value.map((i) => {
                        return i.expression;
                    });
                }
            },
            set(v) {
            }
        },

        filters: {
            get() {
                return this.value.map((i) => {
                    return i.type;
                });
            },
            set(v) {
            }
        },

        filterEverything: {
            get() {
                if (!this.value || this.value.length === 0) {
                    return 'EXCLUDE';
                }

                const lastItem = this.value[this.value.length-1];
                if (lastItem && lastItem.expression === '.') {
                    return lastItem.type;
                } else {
                    return 'EXCLUDE';
                }
            },
            set(v) {

                const newList = (!this.value) ? [] : this.value.slice(0);

                if (newList.length > 0 && newList[newList.length-1].expression === '.') {
                    newList[newList.length-1].type = v;
                } else {
                    newList.push({
                        expression: '.',
                        type: v
                    });
                }

                this.$emit('input', newList);
            }
        },
    },

    methods: {
        onEnter($e) {
            if ($e.which === 13) {
                $e.preventDefault();
                this.addUrl();
            }
        },

        addUrl() {
            const newList = (this.value)? this.value.slice(0) : [];
            const newItem = {
                expression: this.url,
                type: this.filter
            };

            if (newList.length > 0 && newList[newList.length-1].expression === '.') {
                newList.splice(newList.length - 1, 0, newItem);
            } else {
                newList.push(newItem);
            }

            this.$emit('input', newList);
            this.url = '';
            this.filter = 'INCLUDE';
        },

        changeUrl(newVal, idx) {
            const newList = this.value.slice(0);

            if (newList[idx].expression === newVal) {
                return;
            }

            newList[idx].expression = newVal;

            this.$emit('input', newList);
        },

        changeFilter(newVal, idx) {
            const newList = this.value.slice(0);

            if (newList[idx] === newVal) {
                return;
            }
            newList[idx].type = newVal;

            this.$emit('input', newList);
        }
    }
}
</script>
